import React from 'react';
import './EditButton.scss';

interface EditButtonProps {
  /** Whether currently in edit mode */
  isEditing: boolean;
  /** Function to toggle edit mode */
  onToggle: () => void;
  /** Custom class name */
  className?: string;
  /** Whether button is disabled */
  disabled?: boolean;
}

/**
 * Generic Edit/Cancel toggle button component
 * Switches between "Edit" and "Cancel" based on editing state
 */
const EditButton: React.FC<EditButtonProps> = ({
  isEditing,
  onToggle,
  className = '',
  disabled = false
}) => {
  return (
    <button
      className={`edit-button ${className}`}
      onClick={onToggle}
      disabled={disabled}
      type="button"
    >
      {isEditing ? 'Cancel' : 'Edit'}
    </button>
  );
};

export default EditButton;
